import {Outlet} from "react-router-dom";
import React from "react";

const LoginLayout = () => {
  return <div className='flex-grow-1'>
    <Outlet />
  </div>
}
export default LoginLayout
